import { ActionButtonSkeleton, ButtonPanel } from 'components/secondaryMarket/shared/status';
import { PanelHeader } from 'components/secondaryMarket/shared/status/Panel';
import { FC } from 'react';

export const SkeletonSidePanel: FC = () => (
  <div className="d-flex flex-column h-100 overflow-y-auto">
    <PanelHeader color="primary" discreet />
    <div className="flex-grow-1" />
    <ButtonPanel>
      <ActionButtonSkeleton />
    </ButtonPanel>
  </div>
);
SkeletonSidePanel.displayName = 'SkeletonSidePanelySidePanel';
